<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import type { SelectClearableDefinition, SelectNumberClearableDefinition } from 'header/types';

    interface Props {
        field: SelectClearableDefinition | SelectNumberClearableDefinition;
    }

    let { field }: Props = $props();

    type Options =
        | SelectClearableDefinition['options'][number]
        | SelectNumberClearableDefinition['options'][number];

    let options = $derived(field.options as Options[]);
    let selectedIndex = $derived(field.options.findIndex(option => option.key === field.value));

    const dispatch = createEventDispatcher();
    const onChange = (e: { currentTarget: HTMLSelectElement }) => {
        if (e.currentTarget.value === 'null')
            return dispatch('change', {
                field: {
                    ...field,
                    value: null,
                },
            });

        const optionIndex = parseInt(e.currentTarget.value, 10);
        const value = field.options[optionIndex]?.key || field.value;

        dispatch('change', {
            field: {
                ...field,
                value,
            },
        });
    };
</script>

<select
    class="select"
    disabled={field.changeable === false}
    value={selectedIndex}
    oninput={onChange}
>
    <option value={null}>---</option>
    {#each options as { label }, index}
        <option value={index}>{label}</option>
    {/each}
</select>

<style lang="scss" scoped>
    .select {
        width: 100%;
    }
</style>
